import { z } from 'zod';

export const leadSchema = z.object({
  name: z.string().max(50, 'Имя — до 50 символов').optional(),
  company: z.string().max(100, 'Название — до 100 символов').optional(),
  budget: z
    .enum(['<500K', '500K-1M', '1M-3M', '3M+', 'undefined'])
    .optional(),
  pain: z
    .string()
    .min(20, 'Расскажите чуть подробнее — от 20 символов')
    .max(2000, 'Сократите до 2000 символов — детали обсудим на звонке'),
  contact: z
    .string()
    .min(3, 'Укажите Telegram, email или телефон')
    .refine(
      (v) =>
        /^@[A-Za-z0-9_]{3,}$/.test(v) ||
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
        /^(\+7|7|8)[\s\-]?\(?\d{3}\)?[\s\-]?\d{3}[\s\-]?\d{2}[\s\-]?\d{2}$/.test(v),
      'Укажите Telegram (@username), email или телефон +7...',
    ),
  consent: z.literal(true, {
    error: 'Без согласия на обработку данных отправить не получится',
  }),
});

export type LeadInput = z.infer<typeof leadSchema>;
